// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.split-view-container {
  display: flex;
  flex-direction: row;
  flex: 1 1 auto;
  height: 100%;
  width: 100%;
  min-height: 0;
  overflow: hidden;
}

/* 칸은 flex 여야 한다 — block + overflow:auto 면 편집기(.sql-editor-inner-container 의 flex-grow)가 높이를 못 받아
   문서 전체 높이로 늘어나고, 칸에 세로 스크롤바가 생기며 미니맵(height:100%)이 그 높이로 깨졌다(신고 2026-11-04).
   App.css 의 .sql-editor-inner-container 주석과 같은 원인이다 */
.split-view-pane {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-width: 0;
  min-height: 0;
  height: 100%;
}

.split-view-divider {
  flex-shrink: 0;
  width: 6px;
  background: #e8ecf0;
  cursor: col-resize;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
}

.split-view-divider:hover {
  background: #c0d0e0;
}

.split-view-divider-handle {
  width: 3px;
  height: 40px;
  background: #aaa;
  border-radius: 2px;
}

.split-view-divider:hover .split-view-divider-handle {
  background: #666;
}

.split-view-secondary {
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/components/SplitView.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;;sDAEsD;AACtD;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".split-view-container {\n  display: flex;\n  flex-direction: row;\n  flex: 1 1 auto;\n  height: 100%;\n  width: 100%;\n  min-height: 0;\n  overflow: hidden;\n}\n\n/* 칸은 flex 여야 한다 — block + overflow:auto 면 편집기(.sql-editor-inner-container 의 flex-grow)가 높이를 못 받아\n   문서 전체 높이로 늘어나고, 칸에 세로 스크롤바가 생기며 미니맵(height:100%)이 그 높이로 깨졌다(신고 2026-11-04).\n   App.css 의 .sql-editor-inner-container 주석과 같은 원인이다 */\n.split-view-pane {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  min-width: 0;\n  min-height: 0;\n  height: 100%;\n}\n\n.split-view-divider {\n  flex-shrink: 0;\n  width: 6px;\n  background: #e8ecf0;\n  cursor: col-resize;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s;\n}\n\n.split-view-divider:hover {\n  background: #c0d0e0;\n}\n\n.split-view-divider-handle {\n  width: 3px;\n  height: 40px;\n  background: #aaa;\n  border-radius: 2px;\n}\n\n.split-view-divider:hover .split-view-divider-handle {\n  background: #666;\n}\n\n.split-view-secondary {\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
